import { render, staticRenderFns } from "./ourCompany.vue?vue&type=template&id=00e5e725&scoped=true&"
import script from "./ourCompany.vue?vue&type=script&lang=js&"
export * from "./ourCompany.vue?vue&type=script&lang=js&"
import style0 from "./ourCompany.vue?vue&type=style&index=0&id=00e5e725&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e5e725",
  null
  
)

export default component.exports